module.exports = __webpack_public_path__ + "img/csatVolume2.867c577c.png";